<template>
  <div>
    <div class="cover cover--small" :style="'background-image: url(' + require('@/assets/cover-contact.jpg') + ')'">
        <h1 class="cover__title">Event Registration</h1>
    </div>

    <template v-if="hasJoined">
      <div class="wrapper wrapper--spaced wrapper--centered white-box">
          <h1 class="title title--spaced">Thank you for registering.</h1>
          <p class="text">A member from our team will be in touch.</p>        
          <p class="text">Together we can turn this province around! </p>            
          <p class="text">- Team Aaron</p>
      </div>
    </template>
    <template v-else>
      <div class="wrapper wrapper--spaced wrapper--centered white-box">
        <h1 class="title title--spaced"> for Aaron's Special Chilliwack Event <br> SPACE IS VERY LIMITED</h1>
        <div style="margin-bottom: 20px">
          <div class="events__content">
            <div class="events__location">
                <img style="width: 40px;margin-bottom:10px" class="events__icon" src="@/assets/map-pin.svg" alt=""/>
                <div>
                  <p class="events__city">Chilliwack</p>
                  <p class="events__address">Venue: Register for details</p>
                </div>
            </div>
          </div>
          <div class="events__content">
            <p class="events__date">Saturday, November 6th @ 12:45PM</p>
          </div>
      </div>
        <p class="text">If you're interested in attending, please submit the form below<br>and a member of our team will be in touch soon with further details including the exact location.</p>
        <form class="form" method="post" action="https://aarongunn.ca/webservices/forms.php">
            <div class="form__item"><label>First Name*</label><input name="firstname" type="text" autocomplete="given-name" required/></div>
            <div class="form__item"><label>Last Name*</label><input name="lastname" type="text" autocomplete="family-name" required/></div>
            <div class="form__item"><label>Email*</label><input name="email" type="email" autocomplete="email" required/></div>
            <div class="form__item"><label>Postal Code*</label><input name="zip" type="text" autocomplete="postal-code" placeholder="V8V 1X4" pattern="[A-Za-z][0-9][A-Za-z][\s]?[0-9][A-Za-z][0-9]" required/></div>
            <div class="form__item"><label>Phone*</label><input name="phone" type="tel" autocomplete="tel" placeholder="123-456-7890" pattern="[1]?[-\s]?[(]?\d{3}[)\s]?[-\s]?\d{3}[-\s]?\d{4}" required/></div>
            <div class="form__item"><label class="option" style="display: flex;"><input type="checkbox" name="volunteer" value="yes"/> I’m interested in learning more about becoming a volunteer</label></div>
            <div class="form__item"><label class="option" style="display: flex;"><input type="checkbox" name="contribution_interest" value="yes"/> I’m interested in learning more about contributing financially</label></div> 
            <input type="hidden" name="source" value="event_nov6_chilliwack"/>            
            <input type="submit" value="Register" class="button button--red" style="margin-top: 30px"/>
        </form>
      </div>
    </template>
  </div>
</template>

<script>
import facebookMixin from '@/videos-mixin.js'
export default {
  created() {

  },
  mixins: [facebookMixin],
  data () {
    return {

    }
  },
  computed: {
    hasJoined () {
      return this.$router.currentRoute.query.hasOwnProperty('added');
    },
    getVideoComputed () {
      return this.getFbVideo(229128302367901);
    }
  },
  methods: {

  }
}
</script>

<style scoped>


</style>
